import type { SavedObjectivesManager } from '@/state/experiments/useSavedObjectives';
import { Bookmark } from 'lucide-react';

type ObjectivesSourceLineProps = { manager: SavedObjectivesManager };

/**
 * "Loaded from X" as a pill beside the card title, plus "Edited since load" once the objectives no
 * longer match what was loaded.
 */
export const ObjectivesSourceLine = ({ manager }: ObjectivesSourceLineProps) => {
  const { source, editedSinceLoad } = manager;
  if (!source) return null;

  return (
    <span className="flex flex-wrap items-center gap-2">
      <span className="bg-field text-dim inline-flex h-6 items-center gap-1.5 rounded-pill px-2.5 text-micro">
        <Bookmark className="size-3 shrink-0" strokeWidth={1.75} aria-hidden="true" />
        Loaded from <strong className="text-foreground font-medium">{source.name}</strong>
      </span>
      {editedSinceLoad ? (
        <span className="border-warn-line bg-warn-bg text-warn inline-flex h-6 items-center gap-1.5 rounded-pill border px-2.5 text-micro">
          <span className="bg-warn size-1.5 rounded-full" aria-hidden="true" />
          Edited since load
        </span>
      ) : null}
    </span>
  );
};
